<section class="partners-section">
  <span class="visually-hidden"
        #partners></span>
  <div class="width-wrapper">
    <h2 class="partners-title">Наши партнеры</h2>

    <ul class="partners-list">
      <li *ngFor="let item of items"
          class="partner-item">
        <a [href]="item.link"
           target="_blank">
          <img [src]="'../../assets/img/'+item.src"
               [alt]="item.alt"
               [width]="item.width"
               [height]="item.height">
        </a>
      </li>
    </ul>

  </div>


</section>


<!----------------------------------->

<!--<ng-container *ngFor="let item of items; index as index; first as first">-->
<!--  <li *ngIf="!item.isHidden"-->
<!--      class="instruction-item"-->
<!--      [class.opened-description]="item.isOpen">-->
<!--    <div class="instruction-wrap">-->
<!--      <span (click)="openHandler(item,index)">{{item.text}}</span>-->
<!--      <button class="open-button"-->
<!--              (click)="openHandler(item, index)">-->
<!--        <span class="visually-hidden">Открыть</span>-->
<!--      </button>-->
<!--    </div>-->
<!--    <div class="instruction-description"-->
<!--         *ngIf="item.isOpen">-->
<!--      <ng-container *ngIf="!first; else video">-->
<!--        <app-instruction-child-list *ngIf="item.childList"-->
<!--                                    [items]="item.childList"-->
<!--                                    [imgPrefix]="item.imgPrefix"></app-instruction-child-list>-->
<!--      </ng-container>-->
<!--    </div>-->
<!--  </li>-->
<!--</ng-container>-->

<!--<ng-template #video>-->
<!--  <div class="video-wrapper" (click)="closeVideo()">-->
<!--    <iframe width="560" height="315" src="https://www.youtube.com/embed/R0t-IHGZU-Y" frameborder="0"-->
<!--            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"-->
<!--            allowfullscreen></iframe>-->
<!--  </div>-->
<!--</ng-template>-->
